import { Header } from './header';
import { HeaderCluster } from './header-cluster';

export class LabHeader implements Header {
  public name = '';
  public clusters: HeaderCluster[] = [];

  constructor(name: string) {
    this.name = name;
    this.clusters = [
      {
        items: [
          {
            name: 'Home',
            url: 'lab/home',
          },
        ],
      },
      {
        items: [
          {
            name: 'Farmácias',
            url: 'lab/farmacias',
          },
        ],
      },
      {
        items: [
          {
            name: 'Plano de Marketing',
            url: 'lab/marketplan',
          },
        ],
      },
      {
        items: [
          {
            name: 'Relatórios',
            url: 'lab/reports',
          },
        ],
      },
    ];
  }
}
